<template>
  <div class="bg-green-50 hidden lg:flex lg:items-center lg:justify-center">
    <div class="bg-green-50 page-section features">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-6 col-lg-4 py-3 wow fadeInUp">
            <div class="d-flex flex-row">
              <div class="img-fluid mr-3">
                <lord-icon
                  src="https://cdn.lordicon.com/fyuvwkhk.json"
                  trigger="hover"
                  style="width: 150px; height: 150px"
                ></lord-icon>
              </div>
              <div>
                <h>Data analysis</h>
                <p>
                  I like to study, and work on concrete problems using
                  statistics and machine learning.
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 py-3 wow fadeInUp">
            <div class="d-flex flex-row">
              <div class="">
                <div class="img-fluid mr-3">
                  <lord-icon
                    src="https://cdn.lordicon.com/rvulxkpr.json"
                    trigger="hover"
                    style="width: 150px; height: 150px"
                  ></lord-icon>
                </div>
              </div>
              <div>
                <h4>Dashboard creation</h4>
                <p>
                  I also like to create dashboards to visualize data and
                  communicate results.
                </p>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 py-3 wow fadeInUp">
            <div class="d-flex flex-row">
              <div class="img-fluid mr-3">
                <lord-icon
                  src="https://cdn.lordicon.com/hyymuwkm.json"
                  trigger="hover"
                  style="width: 150px; height: 150px"
                ></lord-icon>
              </div>
              <div>
                <h5>Digital aspect</h5>
                <p>
                  I like to work on the digital aspect of a project, from
                  creating a showcase website to creating the brand identity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
